(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["litblocks-home-content"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lb-process-video')) {
  customElements.define('lb-process-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      this.ready = true;
      video.controls = false;
      button.hidden = false;
      button.addEventListener('click', () => {
        button.hidden = true;
        video.controls = true;
        const playback = video.play();
        if (playback) playback.catch(() => { video.controls = true; });
        video.focus({ preventScroll: true });
      });
      video.addEventListener('play', () => { button.hidden = true; video.controls = true; });
      video.addEventListener('ended', () => { video.controls = false; button.hidden = false; });
      video.addEventListener('error', () => { button.hidden = true; video.controls = true; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["litblocks-product-tabs"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('lb-product-tabs')){customElements.define('lb-product-tabs',class extends HTMLElement{connectedCallback(){if(this.initialized)return;this.initialized=true;this.tabs=Array.from(this.querySelectorAll('[data-lb-tab]'));this.panels=Array.from(this.querySelectorAll('[data-lb-panel]'));const nav=this.querySelector('nav');nav.setAttribute('role','tablist');this.tabs.forEach((tab,i)=>{tab.setAttribute('role','tab');tab.setAttribute('aria-controls',this.panels[i].id);this.panels[i].setAttribute('role','tabpanel');this.panels[i].setAttribute('aria-labelledby',tab.id);this.panels[i].setAttribute('tabindex','0');tab.addEventListener('click',e=>{e.preventDefault();this.select(i);history.replaceState(null,'',tab.getAttribute('href'));});tab.addEventListener('keydown',e=>{let next=i;if(e.key==='ArrowRight')next=(i+1)%this.tabs.length;else if(e.key==='ArrowLeft')next=(i-1+this.tabs.length)%this.tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=this.tabs.length-1;else return;e.preventDefault();this.select(next);this.tabs[next].focus();});});this.onJump=e=>{const link=e.target.closest('[data-lb-jump]');if(!link)return;const i=this.tabs.findIndex(t=>t.dataset.lbTab===link.dataset.lbJump);if(i<0)return;e.preventDefault();this.select(i);history.replaceState(null,'',this.tabs[i].getAttribute('href'));this.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});this.tabs[i].focus({preventScroll:true});};this.onHash=()=>{const i=this.panels.findIndex(p=>'#'+p.id===location.hash);if(i>=0)this.select(i);};document.addEventListener('click',this.onJump);window.addEventListener('hashchange',this.onHash);const active=this.panels.findIndex(p=>'#'+p.id===location.hash);this.select(active<0?0:active);}select(i){this.tabs.forEach((tab,j)=>{tab.setAttribute('aria-selected',String(i===j));tab.setAttribute('tabindex',i===j?'0':'-1');this.panels[j].hidden=i!==j;});const nav=this.querySelector('nav');const tab=this.tabs[i];if(tab.offsetLeft<nav.scrollLeft)nav.scrollLeft=tab.offsetLeft;else if(tab.offsetLeft+tab.offsetWidth>nav.scrollLeft+nav.clientWidth)nav.scrollLeft=tab.offsetLeft+tab.offsetWidth-nav.clientWidth;}disconnectedCallback(){document.removeEventListener('click',this.onJump);window.removeEventListener('hashchange',this.onHash);}});}

  } catch(e) { console.error(e); }
})();
})();
